export default __webpack_public_path__ + "static/media/successUpload.6fb831eb.svg";